export default __webpack_public_path__ + "static/media/bad-status-banner.afcdf732.jpg";